//Generated File 
export default class GridSize{
	static readonly Large = `Large`;
	static readonly Medium = `Medium`;
	static readonly Small = `Small`;
	static readonly Tiny = `Tiny`;
	static readonly VerySmall = `VerySmall`;
	static readonly XLarge = `XLarge`;
	static readonly XXLarge = `XXLarge`;
}
